import { render, staticRenderFns } from "./PdvUserDateDashboard.vue?vue&type=template&id=6be6b290"
import script from "./PdvUserDateDashboard.vue?vue&type=script&lang=js"
export * from "./PdvUserDateDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports